export function getContentClass(contentType: string) {
  switch (contentType) {
    case 'event':
      return 'bg-banana';
    case 'opportunity':
      return 'bg-mint-700';
    case 'course':
      return 'bg-info-400';
    case 'organisation':
    case 'education_provider':
      return 'bg-deep-400';
    default:
      return '';
  }
}